import React from "react";
import Card from "components/card";
import { Gift, MessageCircle, User } from "lucide-react";

const HistoryList = () => {
    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border">
            <div className="pb-6 p-4">
                <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-emerald-600 to-purple-600 flex items-center justify-center flex-shrink-0">
                        <Gift className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-start justify-between gap-2">
                            <div className="flex-1">
                                <h4 className="font-medium text-[14px]">
                                    Spotify Premium Subscription
                                </h4>
                                <p className="text-[12px] text-slate-700">Spotify</p>
                            </div>
                            <span className="inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 gap-1 transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-primary/90 bg-emerald-100 text-emerald-700 border-emerald-200">
                                35 pts
                            </span>
                        </div>
                        <div className="mt-3 space-y-1">
                            <div className="flex items-center gap-2 text-[12px]">
                                <User className="w-3 h-3 text-slate-700" />
                                <span className="text-slate-700">Gifted to:</span>
                                <span className="font-medium">Ashley Palma</span>
                            </div>
                            <div className="flex items-start gap-2 text-[12px]">
                                <MessageCircle className="w-3 h-3 text-slate-700 mt-0.5" />
                                <span className="text-slate-700 italic">
                                    "happy"
                                </span>
                            </div>
                            <div className="flex items-center gap-2 text-[11px] text-slate-700 mt-2">
                                <span>2025-12-17</span>
                                <span>•</span>
                                <span>3:17 PM</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    )
};
export default HistoryList;